import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http"
import { Injectable, Injector } from "@angular/core"
import { Router } from "@angular/router"
import { Observable, throwError } from "rxjs"
import { catchError } from "rxjs/operators"
import { AuthenticationService } from "../services/authentication.service"
import { LogoutReasonService } from "../services/logout-reason.service"

const SESSION_EXPIRED_STATUSES = [401, 403]

const EXEMPT_URL_FRAGMENTS = ["Security/Session/Employee/Login", "Security/Session/Employee/Change", "Security/Session/Employee/Password/Change", "Password/ForgotPassword", "Password/Agent/Code", "Password/CheckConfirmation", "SignupConfirmation", "broadcast/Log"]

@Injectable()
export class SessionExpiredInterceptor implements HttpInterceptor {
  private isHandling = false

  constructor(private injector: Injector, private router: Router, private logoutReason: LogoutReasonService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (this.isSessionExpired(error) && !this.isExempt(request.url)) {
          this.handleSessionExpired((error as HttpErrorResponse).status, request)
        }
        return throwError(() => error)
      })
    )
  }

  private isSessionExpired(error: unknown): boolean {
    return error instanceof HttpErrorResponse && SESSION_EXPIRED_STATUSES.includes(error.status)
  }

  private isExempt(url: string): boolean {
    return EXEMPT_URL_FRAGMENTS.some((fragment) => url.includes(fragment))
  }

  private handleSessionExpired(status: number, request: HttpRequest<unknown>): void {
    if (this.isHandling || this.isOnLoginRoute()) {
      return
    }
    this.isHandling = true

    this.logoutReason.set("sessionExpired")
    this.injector.get(AuthenticationService).logout(`Session expired - HTTP ${status} ${request.method} ${this.stripQuery(request.url)}`)
    this.isHandling = false
  }

  private stripQuery(url: string): string {
    return url.split("?")[0]
  }

  private isOnLoginRoute(): boolean {
    return this.router.url.startsWith("/login")
  }
}
